module.exports = __webpack_public_path__ + "static/media/sell_request_details_help_4.bf8de0f7.png";